class SearchModal extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector(".modal__close-button").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.querySelector(".offcanvas-overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderSearchIconAccessibility();
  }

  setHeaderSearchIconAccessibility() {
    const searchIconButton = document.querySelector("#header_search__action");
    if (searchIconButton) {
      searchIconButton.setAttribute("role", "button");
      searchIconButton.setAttribute("aria-haspopup", "dialog");
      searchIconButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(searchIconButton);
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        // When opened from the hamburger menu, keep focus on the input so the
        // virtual keyboard that was shown during the user gesture does NOT get
        // stolen by trapFocus calling container.focus().
        const fromMenu = this.classList.contains("from-menu");
        const inputEl = this.querySelector("#Search-In-Modal");
        const containerEl =
          this.querySelector(".search__content_inner") ||
          this.querySelector(".modal__close-button");
        const elementToFocus = fromMenu && inputEl ? inputEl : containerEl;
        if (typeof trapFocus === 'function') trapFocus(containerEl, elementToFocus);
      },
      { once: true }
    );
    document.body.classList.add("body-overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("body-overflow-hidden");
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("search-modal", SearchModal);
document.querySelector("search-modal")?.addEventListener("touchend", (e) => { if (e.target?.id === "predictive__search_overlay") { e.preventDefault(); e.currentTarget.classList.remove("active"); e.target.classList.remove("active"); document.body.classList.remove("body-overflow-hidden"); } }, { capture: true, passive: false });
document.querySelector("search-modal")?.addEventListener("click", (e) => { if (e.target?.id === "predictive__search_overlay") { e.currentTarget.classList.remove("active"); e.target.classList.remove("active"); document.body.classList.remove("body-overflow-hidden"); } }, { capture: true });
let __cfSwipeX = 0, __cfSwipeY = 0;
document.querySelector("search-modal")?.addEventListener("touchstart", (e) => {
  if (e.target?.closest(".search__content_inner")) { __cfSwipeX = e.changedTouches[0].clientX; __cfSwipeY = e.changedTouches[0].clientY; }
}, { capture: true, passive: true });
document.querySelector("search-modal")?.addEventListener("touchend", (e) => {
  const panel = e.target?.closest(".search__content_inner"), overlay = document.getElementById("predictive__search_overlay");
  if (!panel || !overlay) return;
  const dx = e.changedTouches[0].clientX - __cfSwipeX, dy = e.changedTouches[0].clientY - __cfSwipeY;
  if (dx < -80 && Math.abs(dy) < 50) { e.currentTarget.classList.remove("active"); overlay.classList.remove("active"); document.body.classList.remove("body-overflow-hidden"); }
}, { capture: true, passive: true });
const __cfSearchInput = document.getElementById("Search-In-Modal");
const __cfSearchClear = document.querySelector(".cf-search-clear");
const __cfSearchEmpty = document.querySelector("[data-search-empty]");
const __cfSearchResults = document.querySelector("[data-search-results], .predictive-search");
function __cfToggleSearchClear() { if (!__cfSearchInput || !__cfSearchClear) return; __cfSearchClear.hidden = !__cfSearchInput.value.trim(); }
__cfSearchInput?.addEventListener("input", __cfToggleSearchClear);
__cfSearchClear?.addEventListener("touchend", (e) => { e.preventDefault(); __cfSearchInput.value = ""; __cfToggleSearchClear(); __cfSearchInput.focus(); __cfSearchEmpty && (__cfSearchEmpty.hidden = false); __cfSearchResults && (__cfSearchResults.innerHTML = ""); }, { passive: false });
__cfSearchClear?.addEventListener("click", () => { __cfSearchInput.value = ""; __cfToggleSearchClear(); __cfSearchInput.focus(); __cfSearchEmpty && (__cfSearchEmpty.hidden = false); __cfSearchResults && (__cfSearchResults.innerHTML = ""); });
document.querySelectorAll("#header_search__action, .header__actions_btn--search").forEach((btn) => btn.addEventListener("click", () => {
  requestAnimationFrame(() => {
    const input = document.getElementById("Search-In-Modal");
    input && (input.focus({ preventScroll: true }), input.click && input.click());
  });
}, { capture: true }));
const __cfUnifiedTerms = (() => {
  try {
    const el = document.getElementById("cf-search-unified");
    if (!el) return [];
    const data = JSON.parse(el.textContent);
    const models = (data.models || []).filter(Boolean).map(s => s.trim()).filter(Boolean);
    const designs = (data.designs || []).filter(Boolean).map(s => s.trim()).filter(Boolean);
    // MEZCLAR alternando: modelo, diseño, modelo, diseño...
    // Si hay más modelos que diseños, los extras van al final
    const mixed = [];
    const maxLen = Math.max(models.length, designs.length);
    for (let i = 0; i < maxLen; i++) {
      if (i < models.length) mixed.push(models[i]);
      if (i < designs.length) mixed.push(designs[i]);
    }
    return mixed;
  } catch(e) { return []; }
})();
const __cfRecentKey = "covrfly_recent_searches";
const __cfInput = document.getElementById("Search-In-Modal");
const __cfPopularsWrap = document.querySelector("[data-search-populars]");
const __cfUnifiedGrid = document.querySelector("[data-search-unified-grid]");
const __cfRecentsWrap = document.querySelector("[data-search-recents]");
const __cfRecentsList = document.querySelector("[data-search-recents-list]");
const __cfPredictiveBox = document.querySelector("#predictive__search_overlay .predictive-search");
const __cfForm = document.querySelector("#predictive__search_overlay form.search");
const __cfGetRecents = () => { try { return JSON.parse(localStorage.getItem(__cfRecentKey) || "[]"); } catch(e) { return []; } };
const __cfSetRecents = (items) => localStorage.setItem(__cfRecentKey, JSON.stringify(items.slice(0, 5)));
function __cfRenderPopulars() {
  if (!__cfUnifiedGrid) return;
  __cfUnifiedGrid.innerHTML = __cfUnifiedTerms.map(term => `<a class="cf-search-populars__chip" href="/search?q=${encodeURIComponent(term)}&type=product,collection">${term}</a>`).join("");
}
function __cfRenderRecents() { if (!__cfRecentsWrap || !__cfRecentsList) return; const items = __cfGetRecents(); __cfRecentsWrap.hidden = !items.length; __cfRecentsList.innerHTML = items.map(term => `<div class="cf-search-recents__item"><a class="cf-search-recents__link" href="/search?q=${encodeURIComponent(term)}&type=product,collection">${term}</a><button type="button" class="cf-search-recents__delete" data-recent-delete="${term.replace(/"/g, "&quot;")}" aria-label="Eliminar búsqueda"><svg width="24" height="24" viewBox="0 0 24 24" fill="none"><path stroke="currentColor" stroke-width="1.5" d="M18.973 5.027L5.028 18.972m0-13.945l13.944 13.945"/></svg></button></div>`).join(""); }
function __cfToggleEmptyState() { if (!__cfInput || !__cfPopularsWrap) return; const show = !__cfInput.value.trim(); __cfPopularsWrap.hidden = !show; if (__cfPredictiveBox) __cfPredictiveBox.style.display = show ? "none" : ""; if (show) __cfRenderRecents(); }
__cfRenderPopulars();
__cfRenderRecents();
requestAnimationFrame(__cfToggleEmptyState);
["input","focus","blur"].forEach(evt => __cfInput?.addEventListener(evt, __cfToggleEmptyState));
__cfForm?.addEventListener("submit", () => { const q = __cfInput?.value.trim(); if (!q) return; const next = [q, ...__cfGetRecents().filter(item => item.toLowerCase() !== q.toLowerCase())]; __cfSetRecents(next); });
document.addEventListener("click", (e) => { const btn = e.target.closest("[data-recent-delete]"); if (!btn) return; const term = btn.getAttribute("data-recent-delete"); const next = __cfGetRecents().filter(item => item !== term); __cfSetRecents(next); __cfRenderRecents(); }, { capture: true });
document.querySelector(".cf-search-clear")?.addEventListener("click", () => requestAnimationFrame(__cfToggleEmptyState));
document.querySelector(".cf-search-clear")?.addEventListener("touchend", () => requestAnimationFrame(__cfToggleEmptyState), { passive: true });
// Bloque F — Save recent search on predictive result click (mousedown fires before navigation)
document.addEventListener("mousedown", function(e) {
  var link = e.target.closest(".predictive-search a");
  if (!link) return;
  var input = document.getElementById("Search-In-Modal");
  var q = input && input.value.trim();
  if (!q) return;
  var next = [q].concat(__cfGetRecents().filter(function(item) {
    return item.toLowerCase() !== q.toLowerCase();
  }));
  __cfSetRecents(next);
}, { capture: true });
// Bloque G — Save recent search on modal close (tap outside, ×, swipe, Escape)
(function() {
  var modal = document.querySelector("search-modal");
  if (!modal) return;
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].attributeName === "class" && !modal.classList.contains("active")) {
        var input = document.getElementById("Search-In-Modal");
        var q = input && input.value.trim();
        if (q && q.length >= 2) {
          var next = [q].concat(__cfGetRecents().filter(function(item) {
            return item.toLowerCase() !== q.toLowerCase();
          }));
          __cfSetRecents(next);
        }
      }
    }
  });
  observer.observe(modal, { attributes: true, attributeFilter: ["class"] });
})();
